import React, { useState } from "react";
import { Alert, Box, Modal } from "@mui/material";
import { X } from "lucide-react";
import CheckoutPlanPicker from "./CheckoutPlanPicker";

export default function PlanPickerModal({ open, onClose }) {
  const [errorMsg, setErrorMsg] = useState(null);

  const handleClose = () => {
    setErrorMsg(null);
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "calc(100vw - 32px)", sm: 440 },
          maxHeight: "calc(100vh - 32px)",
          overflowY: "auto",
          bgcolor: "#fff",
          borderRadius: "12px",
          boxShadow: 24,
          p: 3,
        }}
      >
        <div className="flex items-start justify-between mb-4">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">Choose a plan</h2>
            <p className="text-sm text-gray-500 mt-0.5">
              Pick a plan to keep using Twilanswer after your trial ends.
            </p>
          </div>
          <X
            className="w-5 h-5 text-gray-400 cursor-pointer shrink-0"
            onClick={handleClose}
          />
        </div>

        {errorMsg && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setErrorMsg(null)}>
            {errorMsg}
          </Alert>
        )}

        <CheckoutPlanPicker onError={setErrorMsg} />
      </Box>
    </Modal>
  );
}
